module.exports = __webpack_public_path__ + "img/Image2.5043270f.jpg";